/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Startup_Nav_DInputs */

const en_mk_sol_startup_nav_d = /** @type {(inputs: Mk_Sol_Startup_Nav_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Few people, too many directions, a runway to protect.`)
};

const id_mk_sol_startup_nav_d = /** @type {(inputs: Mk_Sol_Startup_Nav_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sedikit orang, terlalu banyak arah, runway yang harus dijaga.`)
};

/**
* | output |
* | --- |
* | "Few people, too many directions, a runway to protect." |
*
* @param {Mk_Sol_Startup_Nav_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_startup_nav_d = /** @type {((inputs?: Mk_Sol_Startup_Nav_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Startup_Nav_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_startup_nav_d(inputs)
	return en_mk_sol_startup_nav_d(inputs)
});